module.exports = __webpack_public_path__ + "img/img50.33bf4a08.svg";